const getIsEnteredTabShown = ({
  isCurrentUserChannel,
  isSplashAccount,
}: {
  isCurrentUserChannel?: boolean;
  isSplashAccount?: boolean;
}): boolean => !isCurrentUserChannel && !isSplashAccount;

export default getIsEnteredTabShown;
